import React from 'react';

import type { Props } from './types';

export default function LiteCrmMapListItem({
  isSelected,
  record,
  subtitleKey = 'summary',
  onClick,
  onSelectionToggle,
  ...props
}: Props) {
  return (
    <div className="map-list__item--lite-crm" {...props}>
      <div className="map-list__checkbox">
        <input
          checked={isSelected}
          className="checkbox--lg"
          type="checkbox"
          onChange={onSelectionToggle}
        />
      </div>
      <div>
        <a className="info-window-title clickable" onClick={onClick}>
          {record.displayName}
        </a>
        <div className="text-muted info-window-subtitle">
          {record[subtitleKey]}
        </div>
      </div>
    </div>
  );
}
